import React from "react";
import { Link } from "react-router-dom";

export const ProductCard = ({ product, index = 0 }) => {
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 90}ms` }}
    >
      <div className="relative overflow-hidden rounded-2xl bg-linen aspect-[3/4] mb-4">
        <img
          src={product.images[0]}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
        />
        {product.images[1] && (
          <img
            src={product.images[1]}
            alt={product.name}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100"
          />
        )}
        <span className="absolute top-4 left-4 overline text-[10px] bg-sand/85 backdrop-blur px-3 py-1 text-charcoal">
          Made to Measure
        </span>
      </div>
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-serif text-xl leading-tight">{product.name}</h3>
          <p className="text-charcoal/55 text-sm mt-1">{product.tagline}</p>
        </div>
        <span className="font-sans text-sm whitespace-nowrap pt-1">{product.currency} {product.price}</span>
      </div>
    </Link>
  );
};
